import type { Bordereau, Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauDenumeroterAction from '../actions/BordereauDenumeroterAction';
import BordereauEmettreLeFluxAction from '../actions/BordereauEmettreLeFluxAction';
import BaseBordereauState from './BaseBordereauState';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import MouvementDupliquerAction from '../../mouvements/liquidation/actions/MouvementDupliquerAction';
import BordereauRejeterCollectiviteAction from '../actions/BordereauRejeterCollectiviteAction';

class BordereauNumeroteState extends BaseBordereauState {
  constructor() {
    super();
    this.step = BordereauStateStep.NUMEROTE;
    this.state = BordereauStateType.NUMEROTE;
    this.color = '#006666';
    this.libelle = 'Numéroté';
  }

  getBordereauActions(_bordereau : Bordereau, userRole : UserRole): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
    return [
      new BordereauEmettreLeFluxAction({ isActionPrincipale: true }),
      new BordereauDupliquerAction(),
      ...(userRole === UserRole.ADMIN) ? [
        new BordereauDenumeroterAction({ isSuperUser: true }),
        new BordereauRejeterCollectiviteAction({ isSuperUser: true }),
      ] : [],
    ];
  }

  getMouvementActions(userRole : UserRole): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
    return [
      new MouvementModifierAction({ isReadonly: true }),
      new MouvementDupliquerAction(),
      ...(userRole === UserRole.ADMIN) ? [
        new MouvementModifierAction({ isSuperUser: true }),
      ] : [],
    ];
  }
}

export default BordereauNumeroteState;
